import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import Box from 'components/Box';
import Heading from 'components/Heading';
import UserGeneratedText from 'components/UserGeneratedText';
import { Ranking } from 'components/ContentCards';
import { BASIC } from 'styles/spacingPresets';
var CONTENT_MAX_WIDTH = 820;
function SectionBlock(_ref) {
  var section = _ref.section,
    hasPlaylistNumbering = _ref.hasPlaylistNumbering;
  var name = section.name,
    description = section.description,
    rank = section.rank;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    maxWidth: CONTENT_MAX_WIDTH
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2"
  }, /*#__PURE__*/React.createElement(Ranking, {
    rank: hasPlaylistNumbering ? rank : undefined
  }), name)), description && /*#__PURE__*/React.createElement(Box, {
    maxWidth: CONTENT_MAX_WIDTH,
    mt: "xs",
    fontSize: BASIC.MEDIUM,
    breakpoints: BASIC.BREAKPOINTS,
    overflow: "wrap"
  }, /*#__PURE__*/React.createElement(UserGeneratedText, {
    text: description
  })));
}
export default SectionBlock;